import React, { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { LoadingOverlay } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router-dom';

import { clearSession } from '@/helpers';
import { ROUTES } from '@/constants';

const LogoutPage: React.FC = () => {
  const client = useApolloClient();
  const navigate = useNavigate();

  const location = useLocation();
  const referrerUrl = location.state?.referrer || '';

  useEffect(() => {
    const logout = async () => {
      client.stop();
      await client.clearStore();
      clearSession();

      navigate(ROUTES.login, { state: { referrer: referrerUrl } });
    };

    logout();
  }, []);

  return <LoadingOverlay visible />;
};

export default LogoutPage;
